var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.awards),function(award){return _c('v-icon',{key:award.code,attrs:{"small":""}},[_vm._v(_vm._s(award.mdi_icon))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }